<template>
  <div>
    <div class="row">
      <div class="col-3 offset-9">
        <button class="btn btn-link btn-sm btn-fill btn-wd float-right" @click="selectProducer($event)">
          <i class="fas fa-chevron-left"></i>&nbsp;&nbsp;Seleccionar Productor
        </button>
      </div>
    </div>

    <h5 class="text-center info-text">Complete la información básica del Productor, y pulse SIGUIENTE para crearlo</h5>
    <div class="row justify-content-center mt-4">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label"> Razón Social (*) </label>

          <el-input
            v-model="formData.businessName"
            v-validate="modelValidations.businessName"
            name="businessName"
            placeholder="Razón Social"
            suffix-icon="fas fa-building"
          >
          </el-input>

          <small v-show="businessName.invalid" class="text-danger">
            {{ getError('businessName') }}
          </small>
        </div>

        <div class="form-group">
          <label class="control-label"> CUIT (*) </label>

          <el-input
            v-model="formData.cuit"
            v-validate="modelValidations.cuit"
            name="cuit"
            placeholder="CUIT"
            suffix-icon="fas fa-address-card"
          >
          </el-input>

          <small v-show="cuit.invalid" class="text-danger">
            {{ getError('cuit') }}
          </small>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label"> Dirección (*) </label>

          <el-input
            v-model="formData.address"
            v-validate="modelValidations.address"
            name="address"
            placeholder="Dirección"
            suffix-icon="fas fa-map-marker-alt"
          >
          </el-input>

          <small v-show="address.invalid" class="text-danger">
            {{ getError('address') }}
          </small>
        </div>

        <div class="form-group">
          <label class="control-label"> Teléfono </label>

          <el-input
            v-model="formData.phone"
            v-validate="modelValidations.phone"
            name="phone"
            placeholder="Teléfono"
            suffix-icon="fas fa-phone"
          >
          </el-input>

          <small v-show="phone.invalid" class="text-danger">
            {{ getError('phone') }}
          </small>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-sm-5">
        <div class="form-group">
          <label class="control-label"> Provincia (*) </label>

          <el-select
            v-model="formData.province"
            v-validate="modelValidations.province"
            autocomplete="off"
            filterable
            name="province"
            placeholder="Provincia"
            @change="clearCity"
          >
            <el-option
              v-for="option in provincesOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            >
            </el-option>
          </el-select>

          <small v-show="province.invalid" class="text-danger">
            {{ getError('province') }}
          </small>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group">
          <label class="control-label d-block"> Localidad (*) </label>

          <el-autocomplete
            v-model="formData.cityName"
            v-validate="modelValidations.city"
            :disabled="!formData.province"
            name="city"
            class="w-100"
            placeholder="Localidad"
            :fetch-suggestions="querySearchAsync"
            @select="selectCity"
          >
          </el-autocomplete>

          <small v-show="city.invalid" class="text-danger d-block">
            {{ getError('city') }}
          </small>

          <small v-show="searchError !== ''" class="text-danger d-block">
            {{ searchError }}
          </small>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-12 col-sm-10 mt-3">
        <distributor-select
          v-model="formData.distributor"
          v-validate="modelValidations.distributor"
          name="distributor"
          placeholder="Seleccione Distribuidor"
        />
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-12 col-sm-10 mt-3">
        <div class="form-group">
          <label class="control-label"> Email (*) </label>

          <el-input
            v-model="formData.email"
            v-validate="modelValidations.email"
            name="email"
            placeholder="Email"
            suffix-icon="fas fa-envelope"
          >
          </el-input>

          <small v-show="email.invalid" class="text-danger">
            {{ getError('email') }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Select, Option, Autocomplete } from 'element-ui';
import cityProvinceOptionsMixin from '@/mixins/cityProvinceOptionsMixin';
import DistributorSelect from '../../../components/ModelSelects/DistributorSelect';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Autocomplete.name]: Autocomplete,
    DistributorSelect,
  },

  mixins: [cityProvinceOptionsMixin],

  data() {
    return {
      formData: {
        id: null,
        businessName: '',
        cuit: '',
        email: '',
        phone: '',
        address: '',
        city: null,
        cityName: null,
        province: null,
        distributor: null,
      },

      modelValidations: {
        businessName: {
          required: true,
          min: 5,
        },

        cuit: {
          numeric: true,
          length: 11,
        },

        email: {
          email: true,
        },

        phone: {
          numeric: true,
          min: 10,
        },

        address: {
          required: true,
        },

        city: {
          required: true,
        },

        province: {
          required: true,
        },

        distributor: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['businessName', 'cuit', 'email', 'phone', 'address', 'city', 'province']),
  },

  mounted() {
    if (this.producer && this.producer.city) {
      this.defaultCity = this.producer.city.id;
      this.defaultCityName = this.producer.city.name;
      this.defaultProvince = this.producer.city.province.id;
    }
  },

  methods: {
    selectProducer(e) {
      this.$emit('selectProducer', e);
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll();
    },

    create() {
      return this.$services.resource('producers').create(this.formData);
    },

    clean() {
      this.formData.id = null;
      this.formData.businessName = '';
      this.formData.cuit = '';
      this.formData.email = '';
      this.formData.phone = '';
      this.formData.address = '';
      this.formData.city = null;
      this.formData.province = null;
    },
  },
};
</script>
